const stateDefault =  {};

export default (state = stateDefault, action) => {
  switch (action.type){
    case 'SET_TEMP_WISH_LIST_SHOP':
      let newState = {...state};
      newState[action.shopId] = action.isWishList;
      return newState;
    default:
      return state;
  }
};
